<div class="full-page">
  <div class="maintenance-container text-center">
    <div class="d-flex align-items-center justify-content-center img-wrapper">
      <img src="assets/images/login-registration/Logo.png" class="logo" />
    </div>
    <div class="bg-white content-maintenance rounded-4">
      <div class="text-primary icon material-symbols-outlined mt-lg-2">engineering</div>
      <h5
        class="text-primary mt-3 mb-4 text-uppercase"
        [innerHTML]="'maintenance.page.title' | translate | markdownTranslate"
      ></h5>
      <div class="font-size-14" [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"></div>
      <div class="font-size-14 mt-3" [innerHTML]="'maintenance.page.contact.us' | translate | markdownTranslate"></div>
    </div>
  </div>
</div>
